<dx-popup
  *ngIf="agreementsBoxVisible"
  class="popup pre-reg-popup"
  [showTitle]="true"
  [title]="'Welcome to ' + (supplierCompanyName || 'Medigi')"
  [showCloseButton]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [(visible)]="agreementsBoxVisible"
  [width]="popupWidth"
  maxWidth="1000px"
  minWidth="320px"
  maxHeight="90vh"
  height="auto"
  [resizeEnabled]="true"
  (onShown)="onPopupShown()"
>
  <div class="alert alert-danger"
    data-testid="pre-reg-terms-hard-gate-alert">
    Ordering has not been enabled for your account yet — please accept the
    Terms and Conditions below to place orders.
  </div>
  <h5>
    Your account has been pre-registered by
    {{ supplierCompanyName || 'Medigi' }}. Please <b>scroll down</b> and verify the ship-to addresses
    for your organization below, select your payment terms, and agree to the
    site Terms and Conditions. You will then have access to the portal.
  </h5>
  <h3 *ngIf="facilities?.length > 0">Pre-Registered Facilities:</h3>
  <div *ngIf="facilities?.length > 0" class="row">
    <div *ngFor="let facility of facilities" class="col-lg-4 col-md-6 col-12">
      <div class="card mb-2 shadow-sm">
        <div class="card-header bg-light">
          <h5 class="card-title mb-0">{{ facility.name }}</h5>
        </div>
        <div class="card-body" style="padding: 0.5rem !important">
          <div class="row">
            <!-- Left Column -->
            <div class="col-md-6">
              <div class="mb-1">
                <h6 class="text-muted mb-1">Facility Information</h6>
                <div class="d-flex align-items-center mb-1">
                  <i class="text-primary"></i>
                  <span>{{ facility.name }}</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <i class="text-primary"></i>
                  <span>{{ facility.phone }}</span>
                </div>
<!--                <div class="d-flex align-items-center mb-1">-->
<!--                  <i class="text-primary"></i>-->
<!--                  <a-->
<!--                    href="mailto:{{ facility.email }}"-->
<!--                    class="text-decoration-none"-->
<!--                    >{{ facility.email }}</a-->
<!--                  >-->
<!--                </div>-->
              </div>
            </div>

            <!-- Right Column -->
            <div class="col-md-6">
              <div class="mb-1">
                <h6 class="text-muted mb-1">Licenses</h6>
                <div class="d-flex align-items-center mb-1">
                  <i class="text-primary"></i>
                  <div>
                    <div>
                      DEA:
                      {{
                        !facility.dea_number ||
                        facility.dea_number.startsWith('NODEA')
                          ? 'Not On File'
                          : facility.dea_number
                      }}
                    </div>
                    <small
                      [ngClass]="{
                        'text-muted': facility.dea_license_expired,
                        'text-success': !facility.dea_license_expired,
                      }"
                    >
                      {{
                        facility.dea_license_expired
                          ? 'Expiry Not On File'
                          : 'Active'
                      }}
                    </small>
                  </div>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <i class="text-primary"></i>
                  <div>
                    <div>
                      State Li#:
                      {{
                        facility.state_license ? facility.state_license : 'None'
                      }}
                    </div>
                    <small
                      [ngClass]="{
                        'text-danger': facility.state_license_expired,
                        'text-success': !facility.state_license_expired,
                      }"
                    >
                      {{
                        facility.state_license_expired ? 'Expired' : 'Active'
                      }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Delivery Address -->
          <div class="mt-1 pt-1 border-top">
            <h6 class="text-muted mb-1">Delivery Address</h6>
            <div class="d-flex">
              <i class="mt-1 text-primary"></i>
              <div>
                <div>{{ facility.delivery_address.line_1 }}</div>
                <div *ngIf="facility.delivery_address.line_2">
                  {{ facility.delivery_address.line_2 }}
                </div>
                <div>
                  {{ facility.delivery_address.city }},
                  {{ facility.delivery_address.state }}
                  {{ facility.delivery_address.postal_code }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <h5>
    You can add additional ship-tos once logged in to the portal. If there are
    any issues with the imported data, please contact customer support at
    {{ client?.comm_email || 'info&#64;medigi.com' }}.
  </h5>
  <br />
  <h3>Terms and Conditions</h3>
  <form #regForm (submit)="onSubmit($event)" id="form-user-update">
    <dx-form
      [(formData)]="agreement"
      [readOnly]="false"
      [showColonAfterLabel]="false"
      [showValidationSummary]="true"
      id="form"
      labelLocation="top"
      validationGroup="customerData"
      [formData]="agreement"
      [colCount]="1"
    >
      <dxi-item itemType="group" [colCount]="formColCount">
        <!-- Left Column -->
        <dxi-item itemType="group" colSpan="1" cssClass="pr-3">
          <dxi-item
            [visible]="!isAchTermsCompany"
            [editorOptions]="selectTermsOptions"
            editorType="dxSelectBox"
            dataField="selectedTerms"
          >
            <dxo-label
              text="Select Payment Terms"
              [showColon]="true"
            ></dxo-label>
            <dxi-validation-rule
              message="Please select preferred payment terms"
              type="required"
            ></dxi-validation-rule>
          </dxi-item>
          <dxi-item [visible]="isAchTermsCompany">
            <div *dxTemplate>
              <div data-testid="pre-reg-ach-terms">
                <b>Payment Terms:</b> your account is on ACH payment terms —
                Net {{ user?.company?.mi_terms_days }} days.
              </div>
            </div>
          </dxi-item>
        </dxi-item>

        <!-- Right Column -->
        <dxi-item itemType="group" colSpan="1" cssClass="border-left pl-3">
          <dxi-item itemType="group">
            <p>
              The use of this site is governed by the following terms and
              conditions.
            </p>
          </dxi-item>

          <dxi-item itemType="group">
            <div *ngIf="features.marketplaceTerms" class="mb-1">
              <dx-button
                icon="download"
                [text]="'Download Privacy Policy'"
                stylingMode="text"
                type="default"
                (onClick)="
                  navigateToUrl(
                    'assets/docs/MedShortsPrivacyPolicy-11-11-15.pdf'
                  )
                "
                [elementAttr]="{ 'data-testid': 'pre-reg-btn-download-privacy' }"
              ></dx-button>
            </div>
            <div *ngIf="features.marketplaceTerms" class="mb-1">
              <dx-button
                icon="download"
                [text]="'Download Terms of Use'"
                stylingMode="text"
                type="default"
                (onClick)="
                  navigateToUrl(
                    'assets/docs/Medigi_MedShorts_503B.com_Buyer_Terms_of_Use_Last_Updated_Nov_2023.pdf'
                  )
                "
                [elementAttr]="{ 'data-testid': 'pre-reg-btn-download-terms' }"
              ></dx-button>
            </div>
            <div *ngIf="termBlock" class="mb-1">
              <dx-button
                icon="download"
                [text]="'Download Terms'"
                stylingMode="text"
                type="default"
                (onClick)="navigateToUrl(termBlock.url)"
                [elementAttr]="{ 'data-testid': 'pre-reg-btn-download-terms-block' }"
              ></dx-button>
            </div>
            <div *ngFor="let privacyBlock of privacyBlocks" class="mb-1">
              <dx-button
                [text]="privacyBlock.title"
                stylingMode="text"
                type="default"
                (onClick)="showPrivacyBlock(privacyBlock)"
                icon="doc"
                [elementAttr]="{ 'data-testid': 'pre-reg-btn-download-privacy-block' }"
              ></dx-button>
            </div>
          </dxi-item>

          <dxi-item
            [editorOptions]="termsOptions"
            editorType="dxCheckBox"
            dataField="agreedToTerms"
          >
            <dxi-validation-rule
              message="You must agree to the terms"
              type="required"
            ></dxi-validation-rule>
          </dxi-item>
        </dxi-item>
      </dxi-item>

      <!-- Form Actions -->
      <dxi-item itemType="group" colCount="3" cssClass="mt-3">
        <dxi-item itemType="group"></dxi-item>
        <dxi-item itemType="group">
          <dxi-item
            [buttonOptions]="buttonCancelOptions"
            [disabled]="loading"
            itemType="button"
          ></dxi-item>
        </dxi-item>
        <dxi-item itemType="group">
          <dxi-item
            [buttonOptions]="buttonSubmitOptions"
            [disabled]="loading"
            itemType="button"
          ></dxi-item>
        </dxi-item>
      </dxi-item>
    </dx-form>
  </form>
</dx-popup>

<dx-popup
  *ngIf="privacyVisible"
  [(visible)]="privacyVisible"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [deferRendering]="false"
  [dragEnabled]="false"
  [resizeEnabled]="true"
  [showTitle]="true"
  class="popup"
  [title]="selectedPrivacyBlock.title"
>
  <dx-scroll-view>
    <div
      *ngIf="selectedPrivacyBlock.body"
      [innerHtml]="selectedPrivacyBlock.body | bypassSecurity"
    ></div>
  </dx-scroll-view>
</dx-popup>
